<template>
  <div class="w-full flex" v-if="this.toShow == 'login'">
    <div class="flex w-full justify-center mx-6 pt-4 lg:pt-0">
      <div class="flex w-full justify-center">
        <div v-if="breakpoints.w > 1050" class="rounded-l-2xl">
          <app-auth-image />
          <!-- <img style="height:646px;width:511px" src="@/assets/images/Form.png" alt=""> -->
        </div>
        <div
          class="shadow-sm border-2 w-full border-gray-1 md:rounded-r-2xl md:rounded-none rounded-2xl sm:w-4/5 md:w-511px pt-12 md:px-12 px-6 p-1"
        >
          <span class="flex justify-center font-bold text-xl">Login</span>
          <el-form
            @keyup.enter.native="validateForm('loginForm')"
            label-position="top"
            class="my-6 w-full"
            :model="loginForm"
            ref="loginForm"
            :rules="rules"
            label-width="80px"
            size="normal"
          >
            <!-- <el-form-item> -->
            <div
              @click="getGoogleAuthCode"
              class="cursor-pointer p-3 flex justify-center items-center text-sm font-light border border-gray-2 rounded"
            >
              <span class="mr-2"><googleIcon /> </span>
              Sign in with Google
            </div>
            <!-- </el-form-item> -->
            <div class="flex items-center justify-center my-4">
              <hr class="flex-none w-1/4 border-gray-2" />
              <p class="text-xs md:text-normal font-light flex-none grow mx-3">
                or sign in with email
              </p>
              <hr class="border-gray-2 w-1/4" />
            </div>
            <el-form-item label="Email" prop="email">
              <el-input
                placeholder="name@example.com"
                type="email"
                v-model="loginForm.email"
                name="email"
              ></el-input>
            </el-form-item>
            <el-form-item class="pt-4" label="Password" prop="password">
              <el-input
                placeholder="********"
                type="password"
                name="password"
                show-password
                v-model="loginForm.password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item class="my-4">
              <!-- <el-checkbox></el-checkbox>
              <span class="text-sm lg:text-normal font-light pl-4"
                >Keep me logged in</span
              > -->
            </el-form-item>
            <el-form-item>
              <o-button
                @click="validateForm('loginForm')"
                class="text-white"
                :loading="isLoading"
              >
                {{ isLoading ? 'Logging in' : 'Login' }}</o-button
              >
              <span
                class="font-medium flex text-primary justify-center cursor-pointer"
                @click="$router.push('forgot-password')"
                >Forgot password?</span
              >
            </el-form-item>
            <p class="flex justify-center text-sm lg:text-normal">
              Don't have an account?
              <span
                class="text-primary ml-1 cursor-pointer"
                @click="$router.push('sign-up')"
                >Sign up</span
              >
            </p>
          </el-form>
        </div>
      </div>
    </div>
    <div v-if="showBusinessActiveErrorDialog">
      <business-active-error-dialog
        :showDialog="showBusinessActiveErrorDialog"
        @closeDialog="closeDialog"
      />
    </div>
  </div>
  <div class="w-full" v-else-if="toShow == 'authenticationSetUp'">
    <authentication-set-up @completed2fa="toShow = 'verifyAuthentication'" />
  </div>
  <div class="w-full" v-else-if="toShow == 'verifyAuthentication'">
    <verify-authentication />
  </div>
  <!-- <div class="w-full h-screen" v-else-if="toShow == 'pt-widget'">
      <pt-widget/>
    </div> -->
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import {
  HAS_REFRESHED,
  ADMIN_EMAIL,
  ADMIN_BUSINESS_NAME,
  ADMIN_TENANT,
  ADMIN_BUSINESS_ID
} from '@/utils/constants'
export default {
  name: 'Login',
  data () {
    return {
      breakpoints,
      showBusinessActiveErrorDialog: false,
      rules: {
        email: [
          {
            required: true,
            type: 'email',
            message: 'Kindly enter a valid email.',
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: 'Incorrect password',
            trigger: ['blur', 'change']
          }
        ]
      },
      isLoading: false,
      toShow: 'login',
      googleAccessToken: '',
      authSetUp: false,
      loginForm: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    closeDialog () {
      this.showBusinessActiveErrorDialog = false
    },
    async getGoogleAuthCode () {
      const googleUser = await this.$gAuth.signIn()
      const currentUser = googleUser.getAuthResponse()
      this.googleAccessToken = currentUser.access_token
      this.loginWithGoogle()
    },
    clearPossibleAdminDetails () {
      localStorage.removeItem(ADMIN_EMAIL)
      localStorage.removeItem(ADMIN_BUSINESS_NAME)
      localStorage.removeItem(ADMIN_TENANT)
      localStorage.removeItem(ADMIN_BUSINESS_ID)
    },
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.login()
        } else {
          this.$notify.error({
            title: 'Invalid login details',
            message: 'Please complete form to login',
            position: 'top-right'
          })
        }
      })
    },

    login () {
      // remove admin login details (if any)
      this.clearPossibleAdminDetails()
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('auth/login', { ...this.loginForm })
        .then(() => {
          if (!this.authDetails.isBusinessActive) {
            this.showBusinessActiveErrorDialog = true
          } else {
            vm.$message({
              showClose: true,
              message: 'Login Successful',
              type: 'success'
            })
            localStorage.setItem(HAS_REFRESHED, 'false')
            // check if 2fa has been set
            setTimeout(() => {
              this.toShow = this.authDetails.hasSetup2Fa
                ? 'verifyAuthentication'
                : 'authenticationSetUp'
            }, 1000)
          }
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: err,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loginWithGoogle () {
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('auth/googleLogin', { token: this.googleAccessToken })
        .then(() => {
          if (!this.authDetails.isBusinessActive) {
            this.showBusinessActiveErrorDialog = true
          } else {
            vm.$message({
              showClose: true,
              message: 'Login Successful',
              type: 'success'
            })
            localStorage.setItem(HAS_REFRESHED, 'false')
            // check if 2fa has been set
            setTimeout(() => {
              this.toShow = this.authDetails.hasSetup2Fa
                ? 'verifyAuthentication'
                : 'authenticationSetUp'
            }, 1000)
          }
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: err,
            type: 'error'
          })
          this.googleAccessToken = ''
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  components: {
    AppAuthImage: () => import('@/assets/images/AppAuthImage.vue'),
    GoogleIcon: () => import('@/assets/icons/GoogleIcon.vue'),
    AuthenticationSetUp: () =>
      import('@/components/auth/AuthenticationSetUp.vue'),
    VerifyAuthentication: () =>
      import('@/components/auth/VerifyAuthentication.vue'),
    BusinessActiveErrorDialog: () =>
      import('@/components/auth/BusinessActiveErrorDialog.vue')
  },
  computed: {
    authDetails () {
      return this.$store.state.auth.authDetails
    },
    tenantIsOval () {
      return process.env.VUE_APP_TENANT_NAME === this.$tenants.OVAL
    }
  }
}
</script>

<style scoped>
>>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}
>>> .el-checkbox__inner:hover {
  border-color: var(--color-primary);
}
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-form-item {
  margin-bottom: 10px;
}
>>> .el-form-item__label {
  line-height: 25px;
}
>>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--color-primary);
}
>>> .el-input__inner {
  border-radius: 8px;
  border-color: #c7c8d2;
  height: 48px;
}
>>> .el-card__body {
  padding: 10px;
}
</style>
